import _ from 'lodash';
import { createSelector } from 'reselect';

const organizationSelector = state => state.organization;

const scoredCriticalExpertiseItemsSelector = (organization) => {

  const organizationData = organization.data || {};

  return _.filter(organizationData.expertiseItems || [], item => {
    return !item._deleted && item.scored;
  });
}

export default createSelector(
  organizationSelector,
  scoredCriticalExpertiseItemsSelector,
)



// WEBPACK FOOTER //
// ./src/selectors/scoredCriticalExpertiseItemsSelector.js